export const ItemRegistrationHolderPage = {
  registrationTypeLabel: 'Select type of registration holder',
  emailAddressLabel: 'Email address',
  phoneNumberLabel: 'Enter your phone number',
  phoneNumberHelpText: 'Must be an Australian number. Include area code(s) for a landline',
  organisationSearchLabel: 'ABN, ACN and business name',
  registeredBusinessNameLabel: 'Would you like to add a registered business name to this registration? (optional)',
  registeredBusinessAddressLabel: 'Registered business address',
  mailingAddressLabel: 'Mailing address',
  organisationEmailAddressHelpText: 'The best email for this organisation',
  contactMethodToAddLabel: 'What type of contact method would you like to add?',
  secondaryContactMethodToAddLabel: 'What type of secondary contact method would you like to add?',
  residentialAddressLabel: 'Residential address',
  amIRegistrationHolderLabel: 'Are you the registration holder?',
  individualHolderUseMyDetailsLabel: 'Yes',
  individualHolderUseDifferentDetailsLabel: 'No',
  holderFirstNameLabel: 'First name',
  holderMiddleNameLabel: 'Middle name (if applicable)',
  holderLastNameLabel: 'Last name',
  keyContactDetailsBusinessNameLabel: 'ABN, ACN or business name (if applicable)',
  ongoingContactTypeLabel: 'Who will be the ongoing contact?',
  ongoingContactEmailAddressHelpText: "You can enter a shared mailbox or someone else's email address.",
  ongoingContactPhoneNumberLabel: 'Australian mobile or landline',
  ongoingContactPhoneNumberHelpText: 'Include area code(s) for landline numbers.',
};
